import { useState } from "react";
import {
  useBlockers,
  useAddBlocker,
  useRemoveBlocker,
  useTasks,
} from "../../hooks/useTasks";
import { StatusDot } from "../chips";
import { STATUS, type Status } from "../../lib/design";

const selectStyle = {
  font: "inherit",
  fontSize: 12.5,
  border: "1px solid var(--border-3)",
  borderRadius: 6,
  padding: "2px 6px",
  background: "var(--bg)",
  maxWidth: 240,
} as const;

/** Dépendances « bloquée par » (POST/DELETE /{id}/blockers). Le picker liste
 * les autres tâches du tenant ; la résolution du titre passe par le cache. */
export function BlockersSection({ taskId }: { taskId: string }) {
  const blockers = useBlockers(taskId);
  const tasks = useTasks();
  const add = useAddBlocker();
  const remove = useRemoveBlocker();
  const [pick, setPick] = useState("");

  const byId = new Map((tasks.data ?? []).map((t) => [t.id, t]));
  const existing = new Set((blockers.data ?? []).map((b) => b.blocker_task_id));

  const submit = () => {
    if (!pick) return;
    add.mutate({ taskId, blockerTaskId: pick });
    setPick("");
  };

  return (
    <div className="detail-section">
      <div className="detail-section-title">Bloquée par</div>
      {(blockers.data ?? []).map((b) => {
        const t = byId.get(b.blocker_task_id);
        return (
          <div key={b.id} className="prop-row" style={{ alignItems: "center" }}>
            <span
              className="prop-value"
              style={{ display: "inline-flex", alignItems: "center", gap: 8 }}
            >
              <span aria-hidden>⛒</span>
              {t ? (
                <>
                  <StatusDot
                    status={(t.status in STATUS ? t.status : "todo") as Status}
                  />
                  {t.title}
                </>
              ) : (
                <span className="mono" style={{ fontSize: 11 }}>
                  {b.blocker_task_id}
                </span>
              )}
            </span>
            <button
              className="icon-btn"
              style={{ marginLeft: "auto" }}
              onClick={() => remove.mutate({ taskId, blockerId: b.id })}
              aria-label="Retirer la dépendance"
              title="Retirer"
            >
              ×
            </button>
          </div>
        );
      })}
      {(blockers.data ?? []).length === 0 && (
        <div style={{ fontSize: 11.5, color: "var(--ink-ghost)" }}>
          Aucune dépendance.
        </div>
      )}

      <div className="quick-add" style={{ marginTop: 8, gap: 6 }}>
        <select
          style={selectStyle}
          value={pick}
          onChange={(e) => setPick(e.target.value)}
          aria-label="Tâche bloquante"
        >
          <option value="">Ajouter une tâche bloquante…</option>
          {(tasks.data ?? [])
            .filter((t) => t.id !== taskId && !existing.has(t.id))
            .map((t) => (
              <option key={t.id} value={t.id}>
                {t.title}
              </option>
            ))}
        </select>
        <button className="btn" onClick={submit} disabled={!pick}>
          Ajouter
        </button>
      </div>
    </div>
  );
}
